export const scrollToErrorField = () => {
  const errorField = document.querySelector(
    '[data-info="item-modal__error-text"]'
  );

  if (!errorField) return;

  errorField.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
};
